import React from 'react';
import NumberFormat from 'react-number-format';
// nodejs library to set properties for components
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
// import Input from '@material-ui/core/Input';
// import InputLabel from '@material-ui/core/InputLabel';
// import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(1),
  },
}));

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function CustomInput(props) {
  const classes = useStyles();
  const { handleChangeValue, defaultValue } = props;

  return (
    // <Input
    //   id="adornment-amount"
    //   // value={values.amount}
    //   defaultValue={defaultValue ? defaultValue : 0}
    //   onChange={event =>
    //     handleChangeValue(parseFloat(event.target.value !== '' ? event.target.value : 0))
    //   }
    //   // startAdornment={<InputAdornment position="start">$</InputAdornment>}
    //   InputProps={{
    //     inputComponent: NumberFormatCustom,
    //   }}
    // />
    <TextField
      className={classes.formControl}
      // label="react-number-format"
      // value={values.amount}
      defaultValue={defaultValue ? defaultValue : 0}
      onChange={event =>
        handleChangeValue(parseFloat(event.target.value !== '' ? event.target.value : 0))
      }
      id="formatted-numberformat-input"
      InputProps={{
        inputComponent: NumberFormatCustom,
      }}
    />
  );
}

// CustomInput.propTypes = {
//   handleChangeValue: PropTypes.func,
// };
